import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// services
import { MasterService } from "../../services/master.service";
import { MessageService } from "../../services/message.service";
import { StoreService } from "../../services/store.service";
import * as languageLibrary from '../../services/language'
import { formatLastVINDigits, formatPhone } from "src/app/utils/format";
@Component({
    selector: "service",
    templateUrl: "./service.component.html",
    styleUrls: ["./service.component.scss"],
    standalone: false
})
export class ServiceComponent {
    /*
    * Variables
    */
    protected tickets: any;
    
    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // set all words
    protected words = languageLibrary.language
    
    protected lotId: any;
    
    protected formatLastVINDigits = formatLastVINDigits
    
    protected formatPhoneNumber = formatPhone

    /*
    * life cycles
    */
    constructor(private master: MasterService, private ms: MessageService, private store: StoreService, private router: Router) {
    }

    ngOnInit() {
        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)
        this.getTickets()
    }


    protected getTickets() {
        this.master.get(`service?lotId=${this.lotId}`, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.tickets = res.data.tickets

        })
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break
            case 'changeLot':
                if (this.lotId === e.lot) {
                    return
                }
                this.lotId = e.lot || parseInt(localStorage.getItem('lot')) || parseInt(this.store.lotSelected) || 0
                this.getTickets()
                break
        }
    }

}
